import React, { Fragment, useEffect } from 'react'

import { oneOfType, object, oneOf } from 'prop-types'

import CommentsForm from './Components/CommentsForm'
import CommentsList from './Components/CommentsList'
import { useCommentsContext } from './Hooks/useCommentsContext'

function CommentsContainer({ userData }) {
  const { addUserData, userData: contextUserData } = useCommentsContext()

  useEffect(() => {
    if (userData && !contextUserData) {
      addUserData(userData)
    }
  }, [userData])

  return (
    <Fragment>
      <CommentsForm />
      <CommentsList />
    </Fragment>
  )
}

CommentsContainer.propTypes = {
  userData: oneOfType([object, oneOf([null])]).isRequired,
}

export default CommentsContainer
